import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { colors } from '../theme'

const Nav = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
  margin-left: 20px;
`
type TabLinkProps = {
  on?: boolean,
}

const TabLink =
  styled(NavLink) <
  TabLinkProps >
  `
  text-decoration: none;
  color: ${colors.foreground};
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s ease;
  font-size: 14px;

  &:hover {
    background: ${colors.primary}15;
    color: ${colors.primary};
  }

  ${(props) =>
    props.on &&
    `
    background: ${colors.primary};
    color: white;
  `}

  &.active {
    background: ${colors.primary};
    color: white;
  }
`

interface TabNavProps {
  resumeId?: string;
}

function TabNav({ resumeId }: TabNavProps) {
  const basePath = resumeId ? `/generator/${resumeId}` : '/generator'

  return (
    <Nav>
      <TabLink to={`${basePath}/ai-chat`}>AI Chat</TabLink>
      <TabLink
        to={`${basePath}/templates`}
        on={!window.location.pathname.includes('/ai-chat')}
      >
        Form
      </TabLink>
    </Nav>
  )
}

export default TabNav
